import { render, staticRenderFns } from "./BatchLoading.vue?vue&type=template&id=18bf8bc7&scoped=true&"
import script from "./BatchLoading.vue?vue&type=script&lang=js&"
export * from "./BatchLoading.vue?vue&type=script&lang=js&"
import style0 from "./BatchLoading.vue?vue&type=style&index=0&id=18bf8bc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf8bc7",
  null
  
)

export default component.exports